import { render, staticRenderFns } from "./AddLocationAmenities.vue?vue&type=template&id=3a606af6&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddLocationAmenities.vue"
export default component.exports